import { notification } from "antd";
import { takeLatest, put } from "redux-saga/effects";
import {
  FETCH_PASS_VIEW_SAGA,
  FETCH_PASS_VIEW_SUCCESS,
  FETCH_PASS_VIEW_FAILURE,
  FETCH_ZONE_VIEW_SAGA,
  FETCH_ZONE_VIEW_SUCCESS,
  FETCH_ZONE_VIEW_FAILURE,
  FETCH_TILT_VIEW_SAGA,
  FETCH_TILT_VIEW_SUCCESS,
  FETCH_TILT_VIEW_FAILURE,
  SET_PASS_VIEW_LOADING,
  SET_ZONE_VIEW_LOADING,
  SET_TILT_VIEW_LOADING,
} from "./types";
import { ADMIN_URL } from "../../config";
import fetch from "../../services/fetch";

function* fetchPassView(action) {
  try {
    yield put({ type: SET_PASS_VIEW_LOADING, payload: true });
    const { project_id, project_name, weld_number } = action.payload;

    const url = new URL(`${ADMIN_URL}/v1/view/pass`);
    url.searchParams.append("project_id", project_id);
    url.searchParams.append("project_name", project_name);
    url.searchParams.append("weld_number", weld_number);

    const res = yield fetch(url.toString(), {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (res.status === 403) {
      throw new Error("Unauthorized");
    }

    const response = yield res.json();

    if (response.statusCode === 200) {
      yield put({
        type: FETCH_PASS_VIEW_SUCCESS,
        payload: response.data,
      });
    } else {
      throw new Error(response.message || "Failed to fetch pass view");
    }
  } catch (error) {
    console.error("Fetch pass view error:", error);
    yield put({
      type: FETCH_PASS_VIEW_FAILURE,
      payload: error.message,
    });
    notification.error({
      message: "Error fetching pass view",
      description: error.message,
    });
  } finally {
    yield put({ type: SET_PASS_VIEW_LOADING, payload: false });
  }
}

function* fetchZoneView(action) {
  try {
    yield put({ type: SET_ZONE_VIEW_LOADING, payload: true });
    const { project_id, project_name, weld_number } = action.payload;

    const url = new URL(`${ADMIN_URL}/v1/view/zone`);
    url.searchParams.append("project_id", project_id);
    url.searchParams.append("project_name", project_name);
    url.searchParams.append("weld_number", weld_number);

    const res = yield fetch(url.toString(), {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (res.status === 403) {
      throw new Error("Unauthorized");
    }

    const response = yield res.json();

    if (response.statusCode === 200) {
      yield put({
        type: FETCH_ZONE_VIEW_SUCCESS,
        payload: response.data,
      });
    } else {
      throw new Error(response.message || "Failed to fetch zone view");
    }
  } catch (error) {
    console.error("Fetch zone view error:", error);
    yield put({
      type: FETCH_ZONE_VIEW_FAILURE,
      payload: error.message,
    });
    notification.error({
      message: "Error fetching zone view",
      description: error.message,
    });
  } finally {
    yield put({ type: SET_ZONE_VIEW_LOADING, payload: false });
  }
}

function* fetchTiltView(action) {
  try {
    yield put({ type: SET_TILT_VIEW_LOADING, payload: true });
    const { project_id, project_name, weld_number } = action.payload;

    const url = new URL(`${ADMIN_URL}/v1/view/tilt`);
    url.searchParams.append("project_id", project_id);
    url.searchParams.append("project_name", project_name);
    url.searchParams.append("weld_number", weld_number);

    const res = yield fetch(url.toString(), {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (res.status === 403) {
      throw new Error("Unauthorized");
    }

    const response = yield res.json();

    if (response.statusCode === 200) {
      yield put({
        type: FETCH_TILT_VIEW_SUCCESS,
        payload: response.data,
      });
    } else {
      throw new Error(response.message || "Failed to fetch tilt view");
    }
  } catch (error) {
    console.error("Fetch tilt view error:", error);
    yield put({
      type: FETCH_TILT_VIEW_FAILURE,
      payload: error.message,
    });
    notification.error({
      message: "Error fetching tilt view",
      description: error.message,
    });
  } finally {
    yield put({ type: SET_TILT_VIEW_LOADING, payload: false });
  }
}

export default function* d360LiveViewsSaga() {
  yield takeLatest(FETCH_PASS_VIEW_SAGA, fetchPassView);
  yield takeLatest(FETCH_ZONE_VIEW_SAGA, fetchZoneView);
  yield takeLatest(FETCH_TILT_VIEW_SAGA, fetchTiltView);
}
